import { render, staticRenderFns } from "./CompanyData.vue?vue&type=template&id=64e76d26&scoped=true"
import script from "./CompanyData.vue?vue&type=script&lang=js"
export * from "./CompanyData.vue?vue&type=script&lang=js"
import style0 from "./CompanyData.vue?vue&type=style&index=0&id=64e76d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e76d26",
  null
  
)

export default component.exports